export const ASTRA_FEATURE_BANNER = {
  type: 'whats_new_banner',
  order: 2
};
export const INVOICING_FEATURE_BANNER = {
  type: 'invoicing-feature-banner',
  order: 1
};

export const TAX_SERVICES_FEATURE_BANNER = {
  type: 'tax-feature-banner',
  order: 0
};

export const WHAT_NEW_BANNER_LIST = [
  INVOICING_FEATURE_BANNER,
  ASTRA_FEATURE_BANNER,
  TAX_SERVICES_FEATURE_BANNER
];
